import List from "@/components/list";
import vue from "@/main";

const Table = args => {
  const { listeners, props } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };
  const goDetail = listeners["goDetail"] || function () { };
  const editMemberInfo = listeners["editMemberInfo"] || function () { };
  const outSchoolDetail = listeners["outSchoolDetail"] || function () { };
  const updateGraduateInfo = listeners["updateGraduateInfo"] || function () { };

  // 删除人员
  function deleteStudent(enroll) {
    vue.$emit("deleteStudent", enroll);
  }
  // 结业
  // function sendGraduation(enroll) {
  //   vue.$emit("sendGraduation", enroll.uuid);
  // }
  // 取消结业
  function cancelGraduation(enroll) {
    vue.$emit("cancelGraduation", enroll.uuid);
  }
  // 编辑班内职务
  function updatePost(enroll) {
    vue.$emit("updatePost", enroll);
  }
  // 删除班委人员
  function deletePost(enroll) {
    vue.$emit("deletePost", enroll);
  }
  //附件下载
  function handleDownloadFile(enroll) {
    if (enroll.attachment) {
      vue.$emit("downloadUserFile", enroll);
    }
  }
  // 设置优秀学员
  function setFineStu(enroll) {
    console.log('set----', enroll.uuid);
    vue.$emit("setExcellent", enroll.uuid);
  }
  // 取消优秀学员
  function cancelFineStu(enroll) {
    console.log('cancel----', enroll.uuid);
    vue.$emit("cancelExcellent", enroll.uuid);
  }

  const UserName = ({ props: { vo } }) => {
    const row = vo.row;
    return (
      <div class="base-hover-char" onClick={() => goDetail(row)}>
        {row.userName}
      </div>
    );
  };

  const Deal = ({ props: { vo } }) => {
    const enroll = vo.row;
    const dealConf = [];
    dealConf.push([
      "icon-remove",
      "移除",
      () => deleteStudent(enroll),
      "enroll:deleteStudent"
    ]);
    // dealConf.push([
    //   "icon-graduation",
    //   "修改结业信息",
    //   () => updateGraduateInfo(enroll),
    //   "enroll:graduation"
    // ]);

    // dealConf.push([
    //   "icon-post",
    //   "编辑班内职务",
    //   () => updatePost(enroll),
    //   "enroll:updatePost"
    // ]);

    dealConf.push([
      "icon-edit",
      "修改学员信息",
      () => editMemberInfo(enroll),
      "classOffline:saveStudent"
    ])

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const UnitPosition = ({ props: { vo } }) => {
    const unitPosition = vo.row.unitPosition ? vo.row.unitPosition : "--";
    return <span>{unitPosition}</span>;
  };

  const GradeStatus = ({ props: { vo } }) => {
    const row = vo.row;
    const flag = row.graduationStatus === 2
    return <div class={flag ? "base-hover-char" : ""} onClick={() => {
      flag && outSchoolDetail(row)
    }}>
      {row.graduationStatusName}
    </div>

  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "姓名",
      prop: "userName",
      minWidth: "120",
      showOverflowTooltip: true,
      render: (vo) => <UserName vo={vo} />,
    },
    // {
    //   label: "工作单位",
    //   prop: "deptName",
    //   minWidth: "150",
    //   showOverflowTooltip: true
    // },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "220",
      showOverflowTooltip: true,
      render: vo => <UnitPosition vo={vo} />
    },
    {
      label: "浙政钉绑定状态",
      prop: "zzdBindStatusStr",
      minWidth: "110",
      showOverflowTooltip: true
    },
    // {
    //   label: "全部课程学习进度",
    //   prop: "learningRate",
    //   minWidth: "150",
    //   showOverflowTooltip: true
    // },
    {
      label: "学习进度",
      prop: "requireLearningRate",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "获取集中培训学时",
      prop: "collectTrainCredit",
      minWidth: "110",
      showOverflowTooltip: true
    },
    {
      label: "结业状态",
      prop: "graduationStatusName",
      minWidth: "80",
      showOverflowTooltip: true,
      render: vo => <GradeStatus vo={vo} />
    },
    // {
    //   label: "优秀学员",
    //   prop: "isExcellentName",
    //   minWidth: "80",
    // },
    // {
    //   label: "班内职务",
    //   prop: "classPostName",
    //   minWidth: "100",
    //   showOverflowTooltip: true
    // },
    // {
    //   label: "培训天数",
    //   prop: "trainDays",
    //   width: "100",
    //   showOverflowTooltip: true,
    // },
    {
      label: "操作",
      fixed: "right",
      width: "140",
      render: vo => <Deal vo={vo} />
    }
  ];
  if (props.isAttachment == 1) {
    AccountTableConfig.splice(4, 0, {
      label: "报名附件",
      width: "80",
      showOverflowTooltip: true,
      render: vo => (
        <el-button
          class="no-padding"
          size="small"
          type="text"
          v-permission="enroll:downloadBatch"
          onClick={() => handleDownloadFile(vo.row)}
        >
          {vo.row.attachmentName}
        </el-button>
      )
    });
  }
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
